// @core/api/endpoints/workflow/delete_pipeline.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/workflow';

/**
 * Delete pipeline
 * Deletes a pipeline and all its versions, schedules, and execution history.
 */
export async function DeletePipeline(
  pipeline_id: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/workflows/pipelines/:pipeline_id`;
  requestPath = requestPath.replace(':pipeline_id', encodeURIComponent(pipeline_id));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
